<template>
    <card :noFooterLine="false" class="today-card" :class="{ 'skeleton' : isSkeleton }" @click.native="cardClick">

        <div slot="image" v-if="image" class="today-card-image" :style="`background-image:url(${image})`"></div>

        <div slot="header" v-if="!isSkeleton">
            <h6 class="card-category" >{{ organised_by }}</h6>
            <h4 class="card-title">{{ title }}</h4>
        </div>

        <skeleton-loading v-if="isSkeleton">
            <row :gutter="{top: '10px', bottom: '10px'}">
                <column :span="1" :gutter="10" class="col-3">
                    <square-skeleton :boxProperties="{ bottom: '0px', height: '80px' }"></square-skeleton>
                </column>
                <column :span="1" :gutter="10" class="col-9">
                    <square-skeleton :boxProperties="{ bottom: '10px', height: '10px', width: '15%' }" backColor="#bdc3c7"></square-skeleton>
                    <square-skeleton :boxProperties="{ bottom: '5px', height: '10px', width: '100%' }" :count="4"></square-skeleton>
                </column>
            </row>
        </skeleton-loading>

        <div slot="footer" v-if="!isSkeleton">
            <span class="card-category text-left">{{ date }}</span> <span class="card-category text-right">{{ venue }}</span>
        </div>  
    </card>
</template>

<script>

import { Card } from 'src/components';
import {Tooltip} from 'element-ui';

export default {
    name: 'TodayCard',
    components: {
        Card,
        [Tooltip.name]: Tooltip,
    },
    props: {
        title: String,
        venue: String,
        organised_by: String,
        date_time: [String, Date],
        image:{
            type: String,
            default: null
        }
    },
    computed: {
        date: function(){
            if(this.date_time){
                let date = new Date(this.date_time)
                return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            }
            else{
                return ''
            }
        },
        isSkeleton: function(){
            return (this.title == undefined || this.title == null) ? true : false
        }
    },
    methods: {
        cardClick(){
            this.$emit('card-click', this.news)
        }
    }
}
</script>

<style lang="scss">

.vue-skeleton-loading .skeleton-bac-animation{
    z-index: 1!important;
}

@keyframes backpos{ 0%{ background-position-x: -100px; } to { background-position-x: 100%; } }

.today-card{
    
    hr {
        margin-top: 0;
        margin-bottom: 0;
    }

    &.skeleton{
        cursor: pointer;

        .card-image,
        .card-header,
        .card-footer,
        .news-card-body{
            display: none;
        }

        .card-body{
            width: 100%;
        }
    }  

    .card-image{
        height: 180px;

        .today-card-image{
            height: 180px;
            background-size: cover;
            background-position: center;
        }
    }


    .card-footer .status-btns .btn{
        margin-right: 3px;
    }

    .card-header .card-title{
        margin-bottom: 0.5rem;
        margin-top: 5px;
        font-size: 1.2em;
    }

    .category, .card-category{
        margin-bottom: 0.2em;
    }

    .card-body{
        padding: 5px 15px 15px 15px;
    }

    .description, 
    .card-description, 
    .footer-big p, 
    .footer .stats{
        color: #353a3e;
    }

    .card-footer{
        span{
            color: #555;
            display: inline-block;
            width: 50%;
        }
    }

} 
</style>
